// Enhance native scroll-hint without replacing its fade, selection or swipe.
class ZentusThumbnailRail extends HTMLElement {
  #controller;
  #resize;
  #mutation;
  #rail;
  #buttons = [];

  connectedCallback() {
    this.#rail = this.querySelector('scroll-hint');
    this.#buttons = [...this.querySelectorAll('[data-rail-step]')];
    if (!this.#rail || this.#buttons.length !== 2) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#rail.addEventListener('scroll', this.#update, { passive: true, signal });
    for (const button of this.#buttons) {
      button.addEventListener('click', () => {
        const rtl = getComputedStyle(this.#rail).direction === 'rtl';
        const step = Number(button.dataset.railStep) * (rtl ? -1 : 1);
        this.#rail.scrollBy({ left: step * this.#rail.clientWidth * 0.75,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
    }
    this.#resize = new ResizeObserver(this.#update);
    this.#resize.observe(this.#rail);
    if (this.#rail.firstElementChild) this.#resize.observe(this.#rail.firstElementChild);
    this.#mutation = new MutationObserver(this.#update);
    this.#mutation.observe(this.#rail, { childList: true, subtree: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#resize?.disconnect();
    this.#mutation?.disconnect();
  }

  #update = () => {
    const items = this.#rail.querySelectorAll('button');
    const bounds = this.#rail.getBoundingClientRect();
    const first = items[0]?.getBoundingClientRect();
    const last = items[items.length - 1]?.getBoundingClientRect();
    const rtl = getComputedStyle(this.#rail).direction === 'rtl';
    const overflow = first && last ? [
      rtl ? first.right > bounds.right + 1 : first.left < bounds.left - 1,
      rtl ? last.left < bounds.left - 1 : last.right > bounds.right + 1,
    ] : [false, false];
    const focused = this.#buttons.indexOf(document.activeElement);
    this.#buttons.forEach((button, index) => { button.hidden = !overflow[index]; });
    if (focused >= 0 && !overflow[focused]) {
      const other = this.#buttons.find((_, index) => overflow[index]);
      (other || [...items].find(item => item.getAttribute('aria-current') === 'true') || items[0])?.focus({ preventScroll: true });
    }
  };
}
if (!customElements.get('zentus-thumbnail-rail')) customElements.define('zentus-thumbnail-rail', ZentusThumbnailRail);
